









































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import AppCheckbox from "@/components/AppCheckbox.vue";

type ModalDataType = { keys: string[] };

export default Vue.extend({
  components: {
    Modal,
    AppCheckbox,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "Generate .csv Report For",
      desc: "",
      blank: true,
      width: "55rem",
      height: "auto",
      withTopRightCloseBtn: true,
      submitBtnText: "Generate",
      cancelBtnText: "Cancel",
    };

    const file_name = ref("");

    // remove html tags and replace spaces with underscores
    const normalize_title = (title: string) => {
      return title.replace(/<[^>]+>/g, "").replace(/ /g, "_");
    };

    const generate_report = () => {
      emit("submit", {
        // @ts-ignore
        name: normalize_title(props.modalData.title),
        keys: report_keys.value
          .filter((key) => key.selected)
          .map((key) => key.id),
      });
    };

    const report_keys: Ref<Array<{ id: string; selected: boolean }>> = ref([]);

    const is_valid = computed(() => report_keys.value.some((d) => d.selected));

    onMounted(() => {
      report_keys.value = (props.modalData as ModalDataType).keys.map((key) => {
        return { id: key, selected: true };
      });
    });

    return {
      config,
      file_name,
      report_keys,
      is_valid,
      generate_report,
    };
  },
});
